module.exports = __webpack_public_path__ + "img/39c5bab3ff0f0ac6fab444936e264564.570c07b4.jpg";